<script lang="ts">
  import { Header, Separator } from "./mod.ts";
  import { Hor, OnDesktop, OnMobile, Spacer, Ver } from "./mod.ts";

  export let customClass: string = "";
  export let title: string | undefined = undefined;
  export let noMargin: boolean = false;
  export let buttonTitle: string = "";
  export let buttonClick: () => void = () => {};
  export let type: "normal" | "emphasis" = "normal";
</script>

<div class="w-full mb-[16px] break-inside-avoid-column {customClass}">
  <div
    class="min-mobile:overflow-hidden h-full border-[0.5px] border-[#CCE2DF] rounded-[10px] shadow-card max-mobile:border-none max-mobile:shadow-none"
    class:bg-grey-10={type === "normal"}
    class:bg-greenGrey-10={type === "emphasis"}
  >
    {#if title}
      <Ver mobileMargin="none" full={false} margin="m" gap="none">
        <Hor margin="none" mobileMargin="none">
          <Header size="4">
            {title}
          </Header>
          <Spacer></Spacer>
          <button
            on:click={buttonClick}
            class="flex items-center text-[14px] font-medium underline"
            class:hidden={!buttonTitle}
          >
            {buttonTitle}
          </button>
        </Hor>
      </Ver>
      <OnDesktop>
        <Separator />
      </OnDesktop>
      <OnMobile>
        <Spacer minSpace="s" />
      </OnMobile>
    {/if}
    <Ver mobileMargin="none" margin={noMargin ? "none" : "m"} gap="none">
      <Ver grow>
        <slot />
      </Ver>
    </Ver>
  </div>
</div>
